<template>
    <div class="rank-list" :data-pblog="pblog">
        <div class="rank-list-title">
            {{ rankTitle }}
        </div>
        <div class="rank-list-content">
            <div
                v-for="(item, index) in rankListInfo" :key="index"
                class="rank-list-item"
                @click="jumpToZone(item)"
            >
                <img :src="item.icon_url" class="rank-list-item-icon">
                <div class="rank-list-item-desc">
                    <div class="rank-list-item-name">{{ item.app_name }}</div>
                    <div v-if="item.download_num" class="rank-list-item-recommend">
                        <span class="rank-list-item-recommend-num">{{ item.download_num }}</span>
                    </div>
                    <div class="rank-list-item-recommend-reason">
                        <span class="rank-list-item-recommend-reason-right">{{ item.desc }}</span>
                    </div>
                </div>
                <div class="item-btn">
                    <div
                        v-if="isIOS"
                        class="rank-list-item-download-btn"
                        @click.stop="download(item)"
                    >
                        {{ item.ios_url === '' ? '进入' : '下载' }}
                    </div>
                    <div
                        v-else
                        class="rank-list-item-download-btn"
                        @click.stop="download(item)"
                    >
                        {{ $root.isHarmonyOS ? '进入' : item.url === ''
                            && item.ad_package_list_data.download_url === '' ? '进入' : '下载' }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isIOS} from '@/utils/browser';
import {getQueryString} from '@/utils/url';
import ck from '@/utils/ck';
import {openPage} from '@/utils/utility';
import {on, off} from '@/utils/dom';
import {debounce} from 'throttle-debounce';
export default {
    props: {
        isRelevantRankList: {
            type: Boolean,
            default: false,
        },
        rankTitle: {
            type: String,
            default: '',
        },
        rankListTab: {
            type: Number,
            default: 0,
        },
        rankList: {
            type: Array,
            default: () => [],
        },
        rankListInfo: {
            type: Array,
            default: () => [],
        },
        info: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isIOS: isIOS(),
            ckUtil: '',
        };
    },
    watch: {
        rankListTab: {
            handler() {
                this.currentTabIndex = this.rankListTab;
            },
        },
        currentTabIndex: {
            handler() {
                this.getRank();
            },
        },
    },
    computed: {
        // 模块展现参数
        pblog() {
            return JSON.stringify({
                gameName: this.info.appName,
                gameId: this.info.appId,
                moduleName: this.rankTitle,
                sid: getQueryString('sid') || '',
                srcId: getQueryString('srcid') || '',
                channelid: getQueryString('channelid') || '',
            });
        },
    },
    mounted() {
        this.ckUtil = ck().getInstance('.rank-list-item-download-btn');
        this.$nextTick(() => {
            on(window, 'scroll', debounce(500, this.moduleShowLog));
        });
    },
    beforeDestroy() {
        // 移除滚动监听事件
        off(window, 'scroll', this.moduleShowLog);
    },
    methods: {
        download(item) {
            // 鸿蒙直接点击跳转落地页
            if (this.$root.isHarmonyOS) {
                window.location.href = `http://gamecenter.baidu.com/static/game/zone.html?srcid=${getQueryString('srcid')}&appId=${item.app_id}&channelid=${getQueryString('channelid')}&query=${item.app_name}&sid=${getQueryString('sid')}#`;
            }
            else {
                // is_adv 1 代表是广告
                if (item.is_adv === 1 && !isIOS()) {
                    const {app_rcv, imTimeSign, download_url} = item.ad_package_list_data;
                    const ckUrl = this.ckUtil.addCkOnUrl(app_rcv, imTimeSign); // 生成ck计费下载链接
                    const img = document.createElement('img');
                    img.src = ckUrl; // 绕过计费串请求链接的跨域问题
                    img.setAttribute('style', 'display:none');
                    document.body.appendChild(img);
                    setTimeout(() => {
                        window.location.href = `http://gamecenter.baidu.com/static/game/zone.html?fc_package_url=${download_url}&isDownload=2&srcid=${getQueryString('srcid')}&appId=${item.app_id}&channelid=${getQueryString('channelid')}&query=${item.app_name}&sid=${getQueryString('sid')}&isFcAdv=1#`;
                    }, 200);
                }
                else if (!isIOS() && item.url) {
                    window.location.href = item.url;
                }
                else if (isIOS() && item.ios_url) {
                    window.location.href = item.ios_url;
                }
                else {
                    window.location.href = `http://gamecenter.baidu.com/static/game/zone.html?srcid=${getQueryString('srcid')}&appId=${item.app_id}&channelid=${getQueryString('channelid')}&query=${item.app_name}&sid=${getQueryString('sid')}#`;
                };
            }
            this.doClickLog(item, 'downloadClick');
        },
        jumpToZone(item) {
            openPage('zone', {
                appId: item.app_id,
                channelid: getQueryString('channelid'),
                srcid: getQueryString('srcid'),
                query: item.app_name,
                sid: getQueryString('sid'),
                isFcAdv: '1', // 是否是商业游戏
            });
            this.doClickLog(item, 'gameRankItem');
        },
        moduleShowLog() {
            this.$logger.inScreen('.rank-list', dataset => {
                const {gameName, moduleName, gameId} = dataset;
                const ext = {
                    ext: {
                        gameName,
                        moduleName,
                        gameId,
                        sid: getQueryString('sid') || '',
                        srcId: getQueryString('srcid') || '',
                        channelid: getQueryString('channelid') || '',
                    },
                };
                this.$logger.display({
                    value: 'module',
                    ext: {
                        item: [
                            {
                                ...ext,
                            },
                        ],
                    },
                });
            });
        },
        doClickLog(item, val) {
            this.$logger.click({
                type: 'click',
                value: val,
                ext: {
                    item: [
                        {
                            ext: {
                                gameName: item.app_name,
                                gameId: item.app_id,
                                is_adv: item.is_adv,
                                moduleName: this.rankTitle,
                                sid: getQueryString('sid') || '',
                                srcId: getQueryString('srcid') || '',
                                channelid: getQueryString('channelid') || '',
                            },
                        },
                    ],
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.rank-list {
    margin: 0 51px;
    overflow: hidden;
    .rank-list-title {
        height: 60px;
        font-family: PingFangSC-Medium;
        font-size: 57px;
        color: #000000;
        letter-spacing: 0;
        line-height: 60px;
        font-weight: 500;
        margin-bottom: 45px;
    }
    .rank-list-tab {
        width: 1140px;
        height: 108px;
        background: #F5F5F5;
        border-radius: 27px;
        display: flex;
        align-items: center;
        margin-bottom: 55px;
        justify-content: space-around;
        .rank-list-tab-active {
            width: 558px;
            height: 96px;
            background: #FFFFFF;
            box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 22px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 42px;
            color: #47B1B3;
            letter-spacing: 0;
            text-align: center;
            line-height: 96px;
            font-weight: 500;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        .rank-list-tab-no-active {
            width: 558px;
            height: 108px;
            text-align: center;
            font-family: PingFangSC-Regular;
            font-size: 42px;
            color: #1F1F1F;
            letter-spacing: 0;
            text-align: center;
            line-height: 108px;
            font-weight: 400;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .rank-list-content {
        .rank-list-item {
            width: 1140px;
            height: 188px;
            display: flex;
            position: relative;
            margin-bottom: 54px;
            align-items: center;
            .rank-list-item-num {
                width: 61px;
                height: 64px;
                margin-right: 45px;
            }
            .rank-list-num-else {
                height: 45px;
                font-family: PingFangSC-Semibold;
                font-size: 45px;
                color: #1F1F1F;
                letter-spacing: 0;
                text-align: center;
                line-height: 45px;
                font-weight: 600;
                margin-right: 65px;
                margin-left: 17px;
                text-align: center;
            }
            .rank-list-item-icon {
                width: 188px;
                height: 188px;
                border-radius: 21.94px;
            }
            .rank-list-item-desc {
                margin-left: 36px;
                .rank-list-item-name {
                    max-width: 500px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    height: 48px;
                    font-family: PingFangSC-Regular;
                    font-size: 48px;
                    color: #1F1F1F;
                    letter-spacing: 0;
                    line-height: 48px;
                    font-weight: 400;
                }
                .rank-list-item-recommend {
                    margin: 27px 0;
                    height: 39px;
                    font-family: PingFangSC-Regular;
                    font-size: 39px;
                    color: #858585;
                    letter-spacing: 0;
                    line-height: 39px;
                    font-weight: 400;
                    .rank-list-item-recommend-num {
                        color: #3388FF;
                    }
                }
                .rank-list-item-recommend-reason {
                    max-width: 550px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    .rank-list-item-recommend-reason-right {
                        height: 39px;
                        font-family: PingFangSC-Regular;
                        font-size: 39px;
                        color: #858585;
                        letter-spacing: 0;
                        line-height: 39px;
                        font-weight: 400;
                    }
                }
            }
            .item-btn {
                .rank-list-item-download-btn {
                    height: 84px;
                    box-sizing: border-box;
                    color: #fff;
                    background: #4e6ef2;
                    font-family: PingFangSC-Medium;
                    font-size: 42px;
                    letter-spacing: 0;
                    text-align: center;
                    line-height: 42px;
                    font-weight: 500;
                    padding: 21px 44px;
                    position: absolute;
                    top: 52px;
                    right: 0;
                    border-radius: 300px;
                }
            }
        }
    }
}
</style>